/**
 * The maintenance bar on top of the console: switched on by Netxol (Netxol Admin → Settings, or deploy/scripts/notice.sh)
 * while an update is being made. The text runs across the bar in the reading direction of the language (right → left
 * in English, left → right in Arabic); with reduced motion it stands still. Read from a public endpoint every minute.
 */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Wrench } from 'lucide-react';
import { useT } from '@/i18n';

export function MaintenanceBar() {
  const t = useT();
  const q = useQuery({ queryKey: ['notice'], queryFn: async () => (await axios.get('/api/core/notice')).data as { on: boolean }, refetchInterval: 60_000, staleTime: 30_000, retry: false });
  if (!q.data?.on) return null;
  const text = t('shell.maint_text');
  const item = <span className="inline-flex items-center gap-2 px-8"><Wrench className="size-3.5 shrink-0" /><b className="font-bold">{t('shell.maint_title')}</b><span>{text}</span></span>;
  return (
    <div role="status" aria-live="polite" className="relative z-40 shrink-0 overflow-hidden bg-gradient-to-r from-[var(--nx-brand-from)] to-[var(--nx-brand-to)] py-1.5 text-[12.5px] text-white shadow-sm" data-testid="maintenance-bar">
      <span className="sr-only">{t('shell.maint_title')} {text}</span>
      <div aria-hidden className="nx-marquee flex w-max whitespace-nowrap">{item}{item}{item}{item}</div>
    </div>
  );
}
